import { GeoCoordinate } from '@/api/fleet-tracking/types';

export function toLatLng(location: GeoCoordinate): google.maps.LatLngLiteral {
  return {
    lat: location.latitude,
    lng: location.longitude
  };
}

export function toLatLngs(locations: GeoCoordinate[]): google.maps.LatLngLiteral[] {
  const latLngs: google.maps.LatLngLiteral[] = [];

  locations.forEach((location) => {
    latLngs.push(toLatLng(location));
  });

  return latLngs;
}

export default {
  toLatLng,
  toLatLngs
};
